/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import SurgicalAppointment from './surgical-appointment';
import SurgicalAppointmentDetail from './surgical-appointment-detail';
import SurgicalAppointmentUpdate from './surgical-appointment-update';
import SurgicalAppointmentDeleteDialog from './surgical-appointment-delete-dialog';

const SurgicalAppointmentRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<SurgicalAppointment />} />
    <Route path="new" element={<SurgicalAppointmentUpdate />} />
    <Route path=":id">
      <Route index element={<SurgicalAppointmentDetail />} />
      <Route path="edit" element={<SurgicalAppointmentUpdate />} />
      <Route path="delete" element={<SurgicalAppointmentDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default SurgicalAppointmentRoutes;
